import React from 'react';
import { Skeleton } from '@mui/material';
import { green, lightBlue, purple } from '@mui/material/colors';
import { LineChart } from '@mui/x-charts';
import { LenderTrendPointViewModel } from '@trnsact/trnsact-shared-types';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { LOOK_TO_BOOK_CHART_HEIGHT } from '../../../../constants';
import { formatMonthLabel, formatPercentValue, mapMonthlyLookToBookDataset } from '../../../../lib';
import { AsyncResource } from '../../../../types';

interface Props {
  resource: AsyncResource<LenderTrendPointViewModel[] | null>;
}

export const MonthlyLookToBookChart = ({ resource }: Props) => {
  const dataset = mapMonthlyLookToBookDataset(resource.data ?? []);

  return (
    <CardContainer title="Monthly Look-to-Book Trend" subTitle="Approval rate / fund rate / look-to-book over time">
      {resource.loading ? (
        <Skeleton variant="rounded" height={LOOK_TO_BOOK_CHART_HEIGHT} />
      ) : (
        <LineChart
          height={LOOK_TO_BOOK_CHART_HEIGHT}
          dataset={dataset}
          margin={{ top: 70 }}
          xAxis={[{ scaleType: 'point', dataKey: 'month', valueFormatter: value => formatMonthLabel(value as string) }]}
          yAxis={[{ min: 0, max: 100, tickMinStep: 20, valueFormatter: value => `${value}%` }]}
          series={[
            {
              dataKey: 'approvalRate',
              label: 'Approval rate',
              color: lightBlue[300],
              curve: 'linear',
              valueFormatter: formatPercentValue,
            },
            {
              dataKey: 'fundRate',
              label: 'Fund rate',
              color: green[400],
              curve: 'linear',
              valueFormatter: formatPercentValue,
            },
            {
              dataKey: 'lookToBook',
              label: 'Look-to-Book',
              color: purple[300],
              curve: 'linear',
              valueFormatter: formatPercentValue,
            },
          ]}
          slotProps={{
            legend: {
              direction: 'row',
              position: { vertical: 'top', horizontal: 'left' },
              itemGap: 24,
              markGap: 8,
              itemMarkWidth: 16,
              itemMarkHeight: 16,
              padding: { bottom: 20 },
            },
          }}
        />
      )}
    </CardContainer>
  );
};
